import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import authReducer from '@features/auth/authSlice';
import ec2Reducer from '@features/ec2/ec2Slice';
import rdsReducer from '@features/rds/rdsSlice';
import s3Reducer from '@features/s3/s3Slice';
import s3RestoreReducer from '@features/s3Restore/s3RestoreSlice';
import urlReducer from '@features/urls/urlSlice';
import dashboardReducer from '@features/dashboard/dashboardSlice';
import notificationReducer from '@features/notifications/notificationSlice';
import userPreferencesReducer from '@features/settings/userPreferencesSlice';
import { apiSlice } from '@services/apiSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    ec2: ec2Reducer,
    rds: rdsReducer,
    s3: s3Reducer,
    s3Restore: s3RestoreReducer,
    urls: urlReducer,
    dashboard: dashboardReducer,
    notifications: notificationReducer,
    userPreferences: userPreferencesReducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['auth/setCredentials', 'auth/logout'],
        ignoredActionPaths: ['meta.arg', 'payload.timestamp'],
        ignoredPaths: ['items.dates'],
      },
    }).concat(apiSlice.middleware),
  devTools: process.env.NODE_ENV !== 'production',
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;